import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../../layouts/Header";
import { Tooltip, Progress, FloatButton } from "antd";
import { useHistory } from "react-router-dom";
import bin from "../../assets/icons/Bin - Copy.svg";
import Plus from "../../assets/icons/Plus.svg";
import { GlobalRequest } from "../../redux/actions/action";
import { API_URL } from "../../redux/constants/type";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const SettingsPlanboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [newTaskStage, setNewTaskStage] = useState("");
  const [newProjectStage, setNewProjectStage] = useState("");
  const [taskStages, setTaskStages] = useState([]);
  const [projectStages, setProjectStages] = useState([]);
  const [taskPermanentStage, setTaskPermanentStage] = useState({});
  const [projectPermanentStage, setProjectPermanentStage] = useState({});
  const { getStageListRes, updateStageRes, addStageRes, deleteStageRes } =
    useSelector((state) => state.user);

  const fetchList = () => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/settings/get`,
        method: "get",
        state: "getStageListRes",
        data: {},
      }),
    );
  };

  const onDragEnd = (result) => {
    if (result.destination === null) return;
    let taskList = [...taskStages];
    let projectList = [...projectStages];

    if (result.type === "TASK") {
      let source = taskList.slice(
        result?.source?.index,
        result?.source?.index + 1,
      )[0];
      taskList.splice(result?.source?.index, 1);
      taskList.splice(result?.destination?.index, 0, source);
      let list = [];
      taskList.map((stage, index) => {
        let main = { ...stage, order: index };
        list.push(main);
      });
      setTaskStages([...list]);
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/settings/update`,
          method: "put",
          state: "updateStageRes",
          data: { projectStages, taskStages: list },
        }),
      );
    }
    if (result.type === "PROJECT") {
      let source = projectList.slice(
        result?.source?.index,
        result?.source?.index + 1,
      )[0];
      projectList.splice(result?.source?.index, 1);
      projectList.splice(result?.destination?.index, 0, source);
      let list = [];
      projectList.map((stage, index) => {
        let main = { ...stage, order: index };
        list.push(main);
      });
      setProjectStages([...list]);
      dispatch(
        GlobalRequest({
          url: `${API_URL}/api/Stage/settings/update`,
          method: "put",
          state: "updateStageRes",
          data: { projectStages: list, taskStages },
        }),
      );
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  useEffect(() => {
    if (getStageListRes?.status === true) {
      const TaskList = getStageListRes?.data?.taskStages;
      const ProjectList = getStageListRes?.data?.projectStages;
      let taskIndex = TaskList?.findIndex((item) => item?.isDefault === true);
      let projectIndex = ProjectList?.findIndex(
        (item) => item?.isDefault === true,
      );
      let obj = TaskList?.slice(taskIndex, taskIndex + 1)[0];
      let obj2 = ProjectList?.slice(projectIndex, projectIndex + 1)[0];
      setTaskPermanentStage(obj);
      setProjectPermanentStage(obj2);
      // TaskList?.splice(taskIndex, 1);
      // ProjectList?.splice(projectIndex, 1);
      setTaskStages([...TaskList]);
      setProjectStages([...ProjectList]);
    }
  }, [getStageListRes]);

  useEffect(() => {
    if (updateStageRes?.status === true) {
      fetchList();
      setNewProjectStage("");
      setNewTaskStage("");
    }
  }, [updateStageRes]);

  useEffect(() => {
    if (addStageRes?.status === true) {
      fetchList();
      setNewProjectStage("");
      setNewTaskStage("");
    }
  }, [addStageRes]);

  useEffect(() => {
    if (deleteStageRes?.status === true) {
      fetchList();
    }
  }, [deleteStageRes]);

  const [typeInScreen, setTypeInScreen] = useState("");
  const [cancelPopupShow, setCancelPopupShow] = useState(false);
  const handleClose = () => setCancelPopupShow(false);

  const handleCancel = (e) => {
    // history.push("/InvoiceAllList");
    history.goBack();
  };

  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  useEffect(() => {
    fetchScreenTranslations("Setting-PlanBoard").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  ///

  const stageChanges = useRef({});

  const registerAllChange = (stageId, type) => {
    return (newStatusName) => {
      stageChanges.current[stageId] = { newStatusName, type };
    };
  };

  const saveAllChanges = () => {
    const changes = stageChanges.current;
    if (Object.keys(changes).length === 0) return;

    // Build updated taskStages with all collected changes
    let updatedTaskStages = [...taskStages];
    updatedTaskStages = updatedTaskStages.map((stage) => {
      const change = changes[stage.statusId];
      return change && change.type === "Task"
        ? { ...stage, statusName: change.newStatusName }
        : stage;
    });

    // Build updated projectStages with all collected changes
    let updatedProjectStages = [...projectStages];
    updatedProjectStages = updatedProjectStages.map((stage) => {
      const change = changes[stage.statusId];
      return change && change.type === "Project"
        ? { ...stage, statusName: change.newStatusName }
        : stage;
    });

    // Dispatch ONCE with all changes
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/settings/update`,
        method: "put",
        state: "updateStageRes",
        data: {
          projectStages: updatedProjectStages,
          taskStages: updatedTaskStages,
        },
      }),
    );

    stageChanges.current = {};
  };

  return (
    <>
      {cancelPopupShow && (
        <CancelWarningModal
          show={cancelPopupShow}
          // onHide={() => setCancelPopupShow(false)}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          handleCancel={handleCancel}
        />
      )}

      {!cancelPopupShow && (
        <RouteLeavingGuard
          when={typeInScreen !== ""}
          navigate={(path) => history.push(path)}
          shouldBlockNavigation={(location) => {
            if (typeInScreen !== "") {
              if (
                ![
                  "/settings-planboard",
                  // "/contactlist/add-company/:id",
                ].includes(location.pathname)
              ) {
                return true;
              }
            }
            return false;
          }}
        />
      )}

      <Header
        leftComponent={
          <div className="d-flex flex-wrap align-items-baseline gap-4">
            <div
              className="projectText"
              style={{ color: "#333333" }}
              onClick={() => history.goBack()}
            >
              {/* Settings */}
              {t("Settings ")}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Plan Boards */}
              {t("Plan Board ")}
            </p>
          </div>
        }
      />
      <div className="st-set-plbrd-main-div">
        <div className="st-set-plbrd-btns">
          <div
            className="d-flex cancel_cont_btn"
            onClick={() => {
              if (typeInScreen !== "") {
                setCancelPopupShow(true);
              } else {
                history.goBack();
              }
            }}
            style={{
              borderRadius: "12px",
              minWidth: "100px",
              minHeight: "35px",
            }}
          >
            <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
              {/* Cancel */}
              {t("Cancel")}
            </p>
          </div>
          <div
            className="d-flex add-buttons"
            style={{
              borderRadius: "12px",
              minWidth: "100px",
              minHeight: "35px",
            }}
            onClick={() => {
              // handleChange();
              saveAllChanges();
              setTypeInScreen("");
              setTimeout(() => {
                history.push("/settings");
              }, 1000);
            }}
          >
            <p className="fw-bold mb-0">
              {/* Change */}
              {t("Change")}
            </p>
          </div>
        </div>
        <div className="st-set-plbrd-grid">
          <div className="st-set-plbrd-grid-single">
            <p className="st-set-plbrd-head m-0">
              {/* TASKS */}
              {t("TASKS")}
            </p>
            <div className="st-under" style={{ marginTop: "6px" }}></div>
            <div className="st-set-plbrd-stage-div">
              <p className="st-set-plbrd-head m-0">
                {/* Stages */}
                {t("Stages")}
              </p>
              <div className="st-set-plbrd-qu-icon">?</div>
              <div className="st-set-plbrd-icon-message">
                {/* You can change, delete or add new stages. For a better
                experience we suggest to have a stage for tasks that need to be
                performed and other for the completed tasks. */}
                {t(
                  "You can change, delete or add new stages. for a better experience we suggest to have a stage for tasks that need to be performed and other for the completed tasks",
                )}
              </div>
            </div>
            <div className="st-fc st-set-plbrd-stages-flex">
              <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                <Droppable
                  droppableId={`123456`}
                  key={`droppable-${123456}`}
                  direction="vertical"
                  type="TASK"
                >
                  {(provided, snapshot) => {
                    return (
                      <div
                        key={`droppable-div-${123456}`}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="st-fc st-set-plbrd-stages-flex"
                        style={{ marginTop: "0" }}
                      >
                        {taskStages?.map((stage, index) => {
                          return (
                            <Draggable
                              key={`draggable-${stage?.statusId}`}
                              draggableId={stage?.statusId}
                              index={index}
                            >
                              {(provided, snapshot) => {
                                return (
                                  <SingleStage
                                    provided={provided}
                                    stage={stage}
                                    index={index}
                                    registerAllChange={registerAllChange}
                                    type="Task"
                                    projectStages={projectStages}
                                    taskStages={taskStages}
                                    setTypeInScreen={setTypeInScreen}
                                    FetchTranslationList={FetchTranslationList}
                                  />
                                );
                              }}
                            </Draggable>
                          );
                        })}
                      </div>
                    );
                  }}
                </Droppable>
              </DragDropContext>
              <div className="st-single-stage-flex">
                <div className="drag-line-flex" style={{ opacity: "0" }}>
                  <hr className="st-under" style={{ margin: "0" }} />
                  <hr className="st-under" style={{ margin: "0" }} />
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">
                    {/* Stage Name */}
                    {t("Stage Name")}
                  </label>
                  <input
                    className="st-single-stage-input"
                    value={newTaskStage}
                    onChange={(e) => {
                      setNewTaskStage(e.target.value);
                      setTypeInScreen(e.target.value);
                    }}
                    maxLength={32}
                  />
                  <div className="st-single-stage-length">
                    {newTaskStage?.length}/32
                  </div>
                </div>

                <Tooltip title="Add task stage" color={""}>
                  <img
                    className={newTaskStage.trim() === "" ? "pointerEvent" : ""}
                    alt=""
                    src={Plus}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      let list = [...taskStages];
                      list.push({
                        order: taskStages?.length,
                        statusName: newTaskStage,
                      });
                      dispatch(
                        GlobalRequest({
                          url: `${API_URL}/api/Stage/settings/add`,
                          method: "post",
                          state: "addStageRes",
                          data: { projectStages, taskStages: list },
                        }),
                      );
                    }}
                  />
                </Tooltip>
              </div>
              <div className="st-single-stage-flex">
                <div className="drag-line-flex" style={{ opacity: "0" }}>
                  <hr className="st-under" style={{ margin: "0" }} />
                  <hr className="st-under" style={{ margin: "0" }} />
                </div>

                <div
                  className="st-single-stage-div d-none"
                  style={{ backgroundColor: "#FAFAFA" }}
                >
                  <label
                    className="st-single-stage-label st-comp-label"
                    style={{
                      backgroundColor: "#FAFAFA",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    {/* Stage Name */}
                    {t("Stage Name")}
                    <div
                      className="st-set-plbrd-qu-icon"
                      style={{ position: "unset" }}
                    >
                      ?
                    </div>
                    <div className="st-set-plbrd-icon-message st-comp-message">
                      <p className="m-0">
                        {/* Archive stage is where the completed tasks are archived. */}
                        {t(
                          "Archive stage is where the completed tasks are archived.",
                        )}
                      </p>
                      <p className="m-0">
                        {/* This stage is mandatory and cannot be deleted. */}
                        {t("This stage is mandatory and cannot be deleted.")}
                      </p>
                    </div>
                  </label>
                  <p
                    className="st-single-stage-input m-0"
                    style={{ height: "fit-content" }}
                  >
                    {taskPermanentStage?.statusName}
                  </p>
                </div>
                <img
                  src={Plus}
                  alt=""
                  style={{ cursor: "default", opacity: "0" }}
                />
              </div>
            </div>
          </div>
          <div className="st-set-plbrd-grid-single">
            <p className="st-set-plbrd-head m-0">
              {/* PROJECTS */}
              {t("PROJECTS")}
            </p>
            <div className="st-under" style={{ marginTop: "6px" }}></div>
            <div className="st-set-plbrd-stage-div">
              <p className="st-set-plbrd-head m-0">
                {/* Stages */}
                {t("Stages")}
              </p>
              <div className="st-set-plbrd-qu-icon">?</div>
              <div className="st-set-plbrd-icon-message">
                {/* You can change, delete or add new stages. For a better
                experience we suggest to have a stage for tasks that need to be
                performed and other for the completed tasks. */}
                {t(
                  "You can change, delete or add new stages. for a better experience we suggest to have a stage for tasks that need to be performed and other for the completed tasks",
                )}
              </div>
            </div>
            <div className="st-fc st-set-plbrd-stages-flex">
              <DragDropContext onDragEnd={(result) => onDragEnd(result)}>
                <Droppable
                  droppableId={`123456`}
                  key={`droppable-${123456}`}
                  direction="vertical"
                  type="PROJECT"
                >
                  {(provided, snapshot) => {
                    return (
                      <div
                        key={`droppable-div-${123456}`}
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        className="st-fc st-set-plbrd-stages-flex"
                        style={{ marginTop: "0" }}
                      >
                        {projectStages?.map((stage, index) => {
                          return (
                            <Draggable
                              key={`draggable-${stage?.statusId}`}
                              draggableId={stage?.statusId}
                              index={index}
                            >
                              {(provided, snapshot) => {
                                return (
                                  <SingleStage
                                    provided={provided}
                                    stage={stage}
                                    index={index}
                                    registerAllChange={registerAllChange}
                                    type="Project"
                                    projectStages={projectStages}
                                    taskStages={taskStages}
                                    setTypeInScreen={setTypeInScreen}
                                    FetchTranslationList={FetchTranslationList}
                                  />
                                );
                              }}
                            </Draggable>
                          );
                        })}
                      </div>
                    );
                  }}
                </Droppable>
              </DragDropContext>
              <div className="st-single-stage-flex">
                <div className="drag-line-flex" style={{ opacity: "0" }}>
                  <hr className="st-under" style={{ margin: "0" }} />
                  <hr className="st-under" style={{ margin: "0" }} />
                </div>
                <div className="st-single-stage-div">
                  <label className="st-single-stage-label">
                    {/* Stage Name */}
                    {t("Stage Name")}
                  </label>
                  <input
                    className="st-single-stage-input"
                    value={newProjectStage}
                    onChange={(e) => {
                      setNewProjectStage(e.target.value);
                      setTypeInScreen(e.target.value);
                    }}
                    maxLength={32}
                  />
                  <div className="st-single-stage-length">
                    {newProjectStage?.length}/32
                  </div>
                </div>

                <Tooltip title="Add project stage" color={""}>
                  <img
                    className={newProjectStage.trim() === "" && "pointerEvent"}
                    alt=""
                    src={Plus}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      let list = [...projectStages];
                      list.push({
                        order: projectStages?.length,
                        statusName: newProjectStage,
                      });
                      dispatch(
                        GlobalRequest({
                          url: `${API_URL}/api/Stage/settings/add`,
                          method: "post",
                          state: "addStageRes",
                          data: { projectStages: list, taskStages },
                        }),
                      );
                    }}
                  />
                </Tooltip>
              </div>
              <div className="st-single-stage-flex">
                <div className="drag-line-flex" style={{ opacity: "0" }}>
                  <hr className="st-under" style={{ margin: "0" }} />
                  <hr className="st-under" style={{ margin: "0" }} />
                </div>

                <div
                  className="st-single-stage-div d-none"
                  style={{ backgroundColor: "#FAFAFA" }}
                >
                  <label
                    className="st-single-stage-label st-comp-label"
                    style={{
                      backgroundColor: "#FAFAFA",
                      display: "flex",
                      gap: "5px",
                    }}
                  >
                    {/* Stage Name */}
                    {t("Stage Name")}
                    <div
                      className="st-set-plbrd-qu-icon"
                      style={{ position: "unset" }}
                    >
                      ?
                    </div>
                    <div className="st-set-plbrd-icon-message st-comp-message">
                      <p className="m-0">
                        {/* Archive stage is where the completed tasks are archived. */}
                        {t(
                          "Archive stage is where the completed tasks are archived.",
                        )}
                      </p>
                      <p className="m-0">
                        {/* This stage is mandatory and cannot be deleted. */}
                        {t("This stage is mandatory and cannot be deleted.")}
                      </p>
                    </div>
                  </label>
                  <p
                    className="st-single-stage-input m-0"
                    style={{ height: "fit-content" }}
                  >
                    {projectPermanentStage?.statusName}
                  </p>
                </div>
                <img
                  src={Plus}
                  alt=""
                  style={{ cursor: "default", opacity: "0" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const SingleStage = ({
  provided,
  index,
  stage,
  type,
  projectStages,
  taskStages,
  setTypeInScreen,
  FetchTranslationList,
  registerAllChange,
}) => {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [statusName, setStatusName] = useState(stage?.statusName);
  const [deletePopupShow, setDeletePopupShow] = useState(false);
  const t = (key) => FetchTranslationList?.[key] || "";

  useEffect(() => {
    if (registerAllChange && statusName !== stage?.statusName) {
      // Register this stage's change with the parent
      registerAllChange(stage?.statusId, type)(statusName);
    }
  }, [statusName, registerAllChange, stage?.statusId, type, stage?.statusName]);

  const handleChange = (e) => {
    if (e.key === "Enter") {
      if (type === "Project") {
        let projectList = [];
        projectStages?.map((stage, index2) => {
          let obj = {
            statusId: stage?.statusId,
            statusName: index === index2 ? statusName : stage?.statusName,
            order: index2,
          };
          projectList.push(obj);
        });
        dispatch(
          GlobalRequest({
            url: `${API_URL}/api/Stage/settings/update`,
            method: "put",
            state: "updateStageRes",
            data: { projectStages: projectList, taskStages },
          }),
        );
      }
      if (type === "Task") {
        let taskList = [];
        taskStages?.map((stage, index2) => {
          let obj = {
            statusId: stage?.statusId,
            statusName: index === index2 ? statusName : stage?.statusName,
            order: index2,
          };
          taskList.push(obj);
        });
        dispatch(
          GlobalRequest({
            url: `${API_URL}/api/Stage/settings/update`,
            method: "put",
            state: "updateStageRes",
            data: { projectStages, taskStages: taskList },
          }),
        );
      }
      return setIsEdit(false);
    }
  };

  const handleDelete = (e) => {
    // dispatch(InvoiceDelete(invoiceDelete));
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/settings/delete/${stage?.statusId}`,
        method: "delete",
        state: "deleteStageRes",
        data: {},
      }),
    );
    setDeletePopupShow(false);
  };

  // to show popup for change stage name and press Enter
  const [showEnterPop, setShowEnterPop] = useState(false);
  const hasShown = useRef(false);
  useEffect(() => {
    if (!hasShown.current) {
      hasShown.current = true; // mark only once

      setShowEnterPop(true);

      const timer = setTimeout(() => {
        setShowEnterPop(false);
      }, 7000);

      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <>
      {deletePopupShow && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={deletePopupShow}
          onHide={() => setDeletePopupShow(false)}
        />
      )}

      <div
        className="st-single-stage-flex"
        key={`${index}-${stage?.statusId}`}
        ref={provided.innerRef}
        {...provided.draggableProps}
      >
        <div
          className="drag-line-flex"
          {...provided.dragHandleProps}
          style={{
            visibility:
              stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473103" ||
              stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473113"
                ? "hidden"
                : "",
          }}
        >
          <hr className="st-under" style={{ margin: "0" }} />
          <hr className="st-under" style={{ margin: "0" }} />
        </div>

        <div className="st-single-stage-div">
          <label className="st-single-stage-label">
            {/* Stage Name */}
            {t("Stage Name")}
          </label>
          {isEdit ? (
            <>
              <Tooltip
                title={
                  <p className="h6 text-black">
                    Change Stage Name and press Enter to make changes reflect
                  </p>
                }
                color={"white"}
              >
                <input
                  className="st-single-stage-input"
                  value={statusName}
                  onChange={(e) => {
                    setStatusName(e.target.value);
                    setTypeInScreen(e.target.value);
                  }}
                  maxLength={32}
                  autoFocus
                  onKeyUp={(e) => {
                    handleChange(e);
                  }}
                />
              </Tooltip>
            </>
          ) : (
            <p
              className="st-single-stage-input m-0"
              style={{ height: "fit-content" }}
              onClick={() => setIsEdit(true)}
            >
              {stage?.statusName}
            </p>
          )}
          <div className="st-single-stage-length">{statusName?.length}/32</div>
        </div>

        <Tooltip title="Delete" color={"red"}>
          <img
            alt=""
            src={bin}
            // className={stage.order === 0 && "hidden"}
            className={
              // stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473101" &&
              // "hidden"
              stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473101" ||
              stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473103" ||
              stage.statusId === "7669991b-57ca-4a7e-bfc3-53dc4cc22f09" ||
              stage.statusId === "08dab011-a6cf-4069-887e-83e5f3473113"
                ? "hidden"
                : ""
            }
            style={{ cursor: "pointer" }}
            // onClick={() => {
            //   dispatch(
            //     GlobalRequest({
            //       url: `${API_URL}/api/Stage/settings/delete/${stage?.statusId}`,
            //       method: "delete",
            //       state: "deleteStageRes",
            //       data: {},
            //     })
            //   );
            // }}

            onClick={() => {
              setDeletePopupShow(true);
            }}
          />
        </Tooltip>
      </div>
    </>
  );
};

export default SettingsPlanboard;
